import TravelType from "../../components/travel-type";
import { fetchTypeList } from "../../utils/api";

const TravelTypeIndex = ({ placesTypeList }) => {
  return <TravelType placesTypeList={placesTypeList} />;
};

export default TravelTypeIndex;

export async function getServerSideProps(props) {
  const { query, req, asPath, res } = props;
  const isServer = req ? true : false;
  const platform = isServer ? "server" : "client";
  let placesTypeList = await fetchTypeList(platform, "all");
  return {
    props: {
      placesTypeList,
    },
  };
}
